//Core Modules
import React, {Fragment} from "react";

//External Module
import Switch from "react-switch";

//User defiend Modules
import Common from "../../Common/Common";
import FormHeader from "../../Common/FormHeader";
import ListTable from "../../Common/ListTable";
import {
    loadCustomFormData,
    showToast,
    convertUTCToLocalTime,
    handleErrorResponse
} from "../../Common/Appcommon";
import CratioTooltip from "../../Common/CratioTooltip";
import { randstr } from '../../Common/Appcommon';
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import TagOperations from "./TagOperations";
import requestApi from "../../services/requestApi.service";

class Tags extends React.Component{

    formname = process.env.REACT_APP_TAG_FORMNAME;

    constructor(props) {
        super(props);

        this.state = {
            page:1,
            limit: process.env.REACT_APP_RECORDS_PER_PAGE,
            totalCount: 0,
            formData: [],
            listFields : [],
            otherInfo : [],
            searchTxt : [],
            filterTxt : [],
            showActionModal : false,
            tagId : '',
            showLoader : false
        }
    }

    componentDidMount = async () => {
        await this.loadFormData();
    };

    loadFormData = async (issearch=false) => {
        const { rowData , listFields, totalCount, otherInfo } =
            await loadCustomFormData(
                issearch,
                this.formname,
                this.state
            );
        this.setState({
            formData: rowData,
            listFields : listFields,
            totalCount : totalCount,
            otherInfo : otherInfo,
        })
    }

    onPageChange = async (page) => {
        this.setState({page},async ()=>{
            await this.loadFormData();
        });
    }

    renderElements = (name,formData) =>{

        if (name === 'groupName'){

            let name = formData['Name'];
            let updatedOn = formData['updatedon'];
            let createdBy = formData['Created Username'];
            let tooltiptxt = "Last Updated User/ Time";

            if(updatedOn !== "" && updatedOn !== null){
                updatedOn = convertUTCToLocalTime(updatedOn);
            }

            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{name}</span>
                        <CratioTooltip title={tooltiptxt} content={<span className={'template-secondary'}>{createdBy}, {updatedOn}</span>} />
                    </div>
                </>
            )
        } else if(name === 'description'){
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{formData['Description']}</span>
                    </div>
                </>
            )
        } else if(name === 'status'){
            const formKey = `${this.formname}_id`;
            return (
                <>
                    <Switch onColor={"#23ae73"} checked={formData['Status'] == "1"} onChange={(status)=>this.updateStatus(formData[formKey],status)} />
                </>
            )
        }

        return <></>;

    }

    toggleActionsModal = async (showActionModal,id='',updateList=false) => {
        this.setState({ showActionModal, tagId : id });

        if(updateList){
            await this.loadFormData();
        }
    }

    handleAddClick = () => {
        this.toggleActionsModal(true);
    }

    initiateEditTag = async(e, tagId) => {
        this.toggleActionsModal(true,tagId);
    }

    onDeleteTag = () => {
        showToast("Deleted Successfully!",'top-right','success');
        this.loadFormData();
    }

    handleSearch = async (name,value) => {

        let { searchTxt } = this.state;
        searchTxt[name] = value;
        this.setState({searchTxt},async ()=>{
            await this.loadFormData(true);
        })
    }

    updateStatus = async (tagId,status) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "STATUS" : (status == true) ? "1" : "0",
            "OPERATION" : 'UPDATE_TAG_STATUS',
            "isOtherApiReq" : true,
            "FORMNAME" : this.formname,
            "FORMID":tagId
        }

        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            await this.loadFormData();
            showToast(`Status updated successfully`);
        }else{
            handleErrorResponse(res.errormsg);
        }
    }

    render(){

        let { formData, listFields, page, totalCount, limit, showActionModal, tagId } = this.state;

        const searchOptions = [
            {
                name : 'Name',
                placeHolder : 'Search by name'
            }
        ];

        listFields =[['Status','Name','Description'],['Status','Name','Description']];

        const customFieldConfig = {
            Name : {
                "render" : "groupName",
                "class" : "text-left"
            },
            Description : {
                "render" : "description",
                "class" : "text-left w-1"
            },
            Status : {
                "render" : "status",
                "disableLink" : true
            }
        };

        const customRowConfig = {
            link : {
                onClick : this.initiateEditTag,
                condition : "",
                class : "row-link"
            }
        }

        const headerFieldConfig = {
            "Name" : {
                "class" : "text-left"
            },
            "Description" : {
                "class" : "text-left w-1"
            }
        };

        let tagButtonOptions = [
            {
                name : 'New Tag',
                label : 'New Tag',
                icon : faCirclePlus,
            }
        ]

        const tagHeader = "Tag";
        const tagDesc = "Tags are a convenient way to organize leads that share similar qualities";

        return (
            <Common pageTitle={"Tag"} mainContent={
            <Fragment>
                <div className="listview-container templates-listview kv-main-wrapper h100per">
                    <FormHeader
                        buttonOptions={tagButtonOptions}
                        handleBtnClick={this.handleAddClick}
                        headerText = {tagHeader}
                        headerDesc = {tagDesc}
                        searchOptions={searchOptions}
                        handleSearch={this.handleSearch}
                        prefix={"tag"}
                    />
                    <ListTable
                        key={Math.random()}
                        formData={formData}
                        fields={listFields}
                        showRowCount={true}
                        spaceBfCell={false}
                        isActionsNeeded={true}
                        isDeleteNeeded={true}
                        deleteCallBack={this.onDeleteTag}
                        config={customFieldConfig}
                        customRowConfig={customRowConfig}
                        renderElements={this.renderElements}
                        noDataMsg={`Tag not found`}
                        pagination={true}
                        onPageChange={this.onPageChange}
                        currentPage={page}
                        totalCount={totalCount}
                        limit={limit}
                        prefix = {"tag"}
                        customClass={'no-border-table'}
                        headerConfig={headerFieldConfig}
                        formName={this.formname}
                    />
                </div>
                <TagOperations
                    key={randstr('tag_')}
                    showActionModal={showActionModal}
                    tagId={tagId}
                    toggleActionsModal={this.toggleActionsModal}
                />
            </Fragment>
            }  showLoader={false} />
        );
    }
}

export default Tags;